import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { SectionWrapper } from '../../../../../styledComponents/Form/Form';
import { SmallModal } from '../../../../../styledComponents/ModalCommon/ModalCommon';
import ModalFormPage from '../../../../../styledComponents/ModalFormPage/ModalFormPage';
import FormCheckboxGroup from '../../../../../styledComponents/UI/Form/FormCheckboxGroup/FormCheckboxGroup';
import {
  EDIT_KE_MEMBERSHIP_OPTIONS_MODAL,
  keMembershipOptionsList,
} from './editKEMembershipOptionsModal.const';
import { useEditKEMembershipOptionsModal } from './editKEMembershipOptionsModal.hooks';

interface IEditKEMembershipOptionsModalProps {
  onModalCancel?: () => void;
  onMembershipOptionsUpdated?: () => void;
  id?: string;
}

const EditKEMembershipOptionsModal = ({
  onModalCancel,
  onMembershipOptionsUpdated,
  id,
}: IEditKEMembershipOptionsModalProps) => {
  const { t } = useTranslation();
  const {
    updateMembershipOptionsHandler,
    membershipOptions,
    isProcessing,
    onCloseHandler,
  } = useEditKEMembershipOptionsModal({ id });

  return (
    <SmallModal
      disabled={isProcessing}
      name={EDIT_KE_MEMBERSHIP_OPTIONS_MODAL + id}
      onModalClose={onModalCancel}
    >
      <Form
        keepDirtyOnReinitialize
        onSubmit={updateMembershipOptionsHandler}
        initialValues={membershipOptions}
      >
        {({ ...renderProps }) => (
          <ModalFormPage
            mode="small"
            handleSubmit={renderProps.handleSubmit}
            isProcessing={isProcessing}
            onCancel={onCloseHandler}
            title={t('headers.edit-options')}
          >
            <SectionWrapper>
              <FormCheckboxGroup
                layout="column"
                options={keMembershipOptionsList}
              />
            </SectionWrapper>
          </ModalFormPage>
        )}
      </Form>
    </SmallModal>
  );
};

export default EditKEMembershipOptionsModal;
